import {
  PenNib, ArrowsClockwise, ShoppingBag, Browsers, MagnifyingGlass,
  Wrench, HardDrives, PaintBrush, Gauge,
} from "@phosphor-icons/react";

export const SERVICES = [
  {
    slug: "custom-website-design",
    icon: PenNib,
    title: "Custom Website Design",
    short: "Bespoke, pixel-perfect websites built from scratch around your brand and goals.",
    span: "md:col-span-2",
    full: "We design and build fully custom websites tailored to your brand identity, audience, and business objectives — no templates, no compromises.",
  },
  {
    slug: "website-redesign",
    icon: ArrowsClockwise,
    title: "Website Redesign",
    short: "Transform an outdated site into a modern, high-converting experience.",
    span: "",
    full: "A strategic redesign that modernizes your look, improves usability, and boosts conversions while preserving your SEO value.",
  },
  {
    slug: "ecommerce-websites",
    icon: ShoppingBag,
    title: "E-commerce Websites",
    short: "Fast, secure online stores that turn browsers into buyers.",
    span: "",
    full: "Conversion-optimized online stores with seamless checkout, product management, and secure payments built to scale.",
  },
  {
    slug: "landing-pages",
    icon: Browsers,
    title: "Landing Pages",
    short: "High-converting pages engineered for campaigns and launches.",
    span: "",
    full: "Focused, persuasive landing pages designed to maximize conversions for your ads, launches, and campaigns.",
  },
  {
    slug: "seo-optimization",
    icon: MagnifyingGlass,
    title: "SEO Optimization",
    short: "Rank higher and get found by the customers who matter.",
    span: "md:col-span-2",
    full: "Technical and on-page SEO that improves your visibility, drives organic traffic, and helps you rank for the searches that matter.",
  },
  {
    slug: "website-maintenance",
    icon: Wrench,
    title: "Website Maintenance",
    short: "Ongoing updates, security, and peace of mind.",
    span: "",
    full: "Keep your site secure, updated, and running perfectly with proactive monitoring and ongoing support.",
  },
  {
    slug: "website-hosting",
    icon: HardDrives,
    title: "Website Hosting",
    short: "Blazing-fast, reliable hosting with 99.9% uptime.",
    span: "",
    full: "Managed, high-performance hosting with SSL, backups, and lightning-fast global delivery.",
  },
  {
    slug: "branding-logo-design",
    icon: PaintBrush,
    title: "Branding & Logo Design",
    short: "A distinctive identity that sets you apart.",
    span: "",
    full: "Memorable logos and cohesive brand systems that make your business instantly recognizable.",
  },
  {
    slug: "performance-optimization",
    icon: Gauge,
    title: "Performance Optimization",
    short: "Core Web Vitals tuned for speed and rankings.",
    span: "md:col-span-2",
    full: "We optimize load times, Core Web Vitals, and overall performance so your site feels instant and ranks better.",
  },
];

export const INDUSTRIES = [
  "All", "Restaurants", "Medical", "Construction", "Real Estate", "Law Firms", "E-commerce", "Local Services",
];

export const WHY = [
  "Custom-built websites",
  "Mobile-first design",
  "SEO-ready development",
  "Fast loading speeds",
  "Ongoing support",
  "Affordable pricing",
  "Local business expertise",
];

export const STATS = [
  { value: 240, suffix: "+", label: "Websites Designed" },
  { value: 180, suffix: "+", label: "Happy Clients" },
  { value: 98, suffix: "/100", label: "Avg. Performance Score" },
  { value: 99, suffix: "%", label: "Customer Satisfaction" },
];
